var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGradientManageCoursesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5311_96323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 22C15.2091 22 17 20.2091 17 18C17 15.7909 15.2091 14 13 14C10.7909 14 9 15.7909 9 18C9 20.2091 10.7909 22 13 22Z",
    stroke: "url(#paint0_linear_5311_96323)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.675 26C7.24261 24.8029 8.13827 23.7915 9.2579 23.0833C10.3775 22.375 11.6752 21.9991 13 21.9991C14.3248 21.9991 15.6225 22.375 16.7421 23.0833C17.8617 23.7915 18.7574 24.8029 19.325 26H27C27.2652 26 27.5196 25.8946 27.7071 25.7071C27.8946 25.5196 28 25.2652 28 25V7C28 6.73478 27.8946 6.48043 27.7071 6.29289C27.5196 6.10536 27.2652 6 27 6H5C4.73478 6 4.48043 6.10536 4.29289 6.29289C4.10536 6.48043 4 6.73478 4 7V25C4 25.2652 4.10536 25.5196 4.29289 25.7071C4.48043 25.8946 4.73478 26 5 26H6.675Z",
    stroke: "url(#paint1_linear_5311_96323)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 22H24V10H8V12",
    stroke: "url(#paint2_linear_5311_96323)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5311_96323",
    x1: 19.7556,
    y1: 13.6,
    x2: 8.9576,
    y2: 20.1262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F28CB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0129,
    stopColor: "#EF89B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2229,
    stopColor: "#BA54A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3807,
    stopColor: "#993393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4673,
    stopColor: "#8D278E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5944,
    stopColor: "#7B298F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8477,
    stopColor: "#4D2E90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E3191"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5311_96323",
    x1: 36.2667,
    y1: 5,
    x2: 7.28466,
    y2: 26.0198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F28CB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0129,
    stopColor: "#EF89B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2229,
    stopColor: "#BA54A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3807,
    stopColor: "#993393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4673,
    stopColor: "#8D278E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5944,
    stopColor: "#7B298F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8477,
    stopColor: "#4D2E90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E3191"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5311_96323",
    x1: 29.5111,
    y1: 9.4,
    x2: 11.6351,
    y2: 23.8054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F28CB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0129,
    stopColor: "#EF89B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2229,
    stopColor: "#BA54A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3807,
    stopColor: "#993393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4673,
    stopColor: "#8D278E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5944,
    stopColor: "#7B298F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8477,
    stopColor: "#4D2E90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E3191"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5311_96323"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientManageCoursesIcon);
export default __webpack_public_path__ + "static/media/gradient_manage_courses_icon.6ddfb031162e8d03d493390ccaa58da0.svg";
export { ForwardRef as ReactComponent };